export default __webpack_public_path__ + "1007afba6203a9279a9ccc1b867e317c.png";